module.exports = require("@deck.gl/extensions");